export const CANVAS_ASSIGNMENT_GROUP_META_REQUEST =
    'CANVAS_ASSIGNMENT_GROUP_META_REQUEST'
export const CANVAS_ASSIGNMENT_GROUP_META_SUCCESS =
    'CANVAS_ASSIGNMENT_GROUP_META_SUCCESS'
export const CANVAS_ASSIGNMENT_GROUP_META_FAILURE =
    'CANVAS_ASSIGNMENT_GROUP_META_FAILURE'
